import { apiGet, API_URI, apiPost } from "./index";
import { Moment } from "moment";
const wordCloud = {
    getAll: async (projectId: number, startDate: Moment, endDate: Moment, streamIds: number[], cloudFilter: string) => {
        if (cloudFilter === "#") {
            cloudFilter = "%23";
        }
        const data = await apiGet(
            `${API_URI}/api/wordcloud/getall?startDate=${startDate.format("DD-MMM-YYYY HH:mm")}&endDate=${endDate.format("DD-MMM-YYYY HH:mm")}&projectId=${projectId}&streamIds=${streamIds.join(",")}&cloudFilter=${cloudFilter}`
        );
        return data;
    },
    getAllByClips: async (projectId: number, startDate: Moment, endDate: Moment, streamIds: number[], cloudFilter: string) => {
        if (cloudFilter === "#") {
            cloudFilter = "%23";
        }

        var wordCloudRequest = {
            projectId: projectId,
            startDate: startDate,
            endDate: endDate,
            streamIds: streamIds,
        };

        const data = await apiPost(`${API_URI}/api/wordcloud/getall/byclips`, wordCloudRequest);
        return data;
    },
    getExclusions: async (projectId: number) => {
        const data = await apiGet(`${API_URI}/api/wordcloud/exclusions/get?projectId=${projectId}`);
        return data;
    },
    includeWord: async (projectId: number, word: string) => {
        const data = await apiGet(`${API_URI}/api/wordcloud/include?projectId=${projectId}&phrase=${word}`);
        return data;
    },
    excludeWord: async (projectId: number, word: string) => {
        const data = await apiGet(`${API_URI}/api/wordcloud/exclude?projectId=${projectId}&phrase=${word}`);
        return data;
    },
};

export default wordCloud;
